<template>
	<section>
		<div class="order-detail">
			<!-- 追击费用弹框 -->
			<add-money v-if="isAddMoney" :order_uuid='orderFollowList.order_info.uuid' @close-modal="onCloseModalClick" @getOrderAdd="getOrderAdd"></add-money>

			<!-- 支付弹框 -->
			<pay-modal :payPrice="payPrice" v-if="isPayModal" :showClose="true" :isAppend="true"
				@close-modal="onCloseModalClick" @payClick='payClick' @goToCharge="goToCharge">
			</pay-modal>

			<!-- 钱包余额不足弹框 -->
			<confirm-modal v-if="noEnough" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
				@leftClick="onCloseModalClick" @rightClick="goToCharge">
			</confirm-modal>

			<!-- 扫码支付 -->
			<qr-code-url v-if="qrcodeUrl" :qrcodeUrl="qrcodeUrl" tips="支付" :chargeMoney="payPrice" @deletePay="onCloseModalClick"></qr-code-url>

			<!-- 追加成功成功弹框 -->
			<toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>

			<!-- 添加进度，申请协助 -->
			<supply-and-follow v-if="isSupplyFollow" :objSupplyFollow="objSupplyFollow" @submitSupplyAdd="submitSupplyAdd" @close-modal="onCloseModalClick"></supply-and-follow>

			<!-- 修改佣金 -->
			<common-modal :showClose="true" v-if="isModifymoney"  @close-modal="onCloseModalClick" class="supply-wrap">
			    <div class="modal">
			        <div class="title">修改佣金</div>
					<p class="aim"><span>订单佣金修改为</span><input type="tel" v-model="modifyCommission"><span>%</span></p>
					<p class="price-modify">订单佣金：<span>￥{{orderFollowList.order_info.commission_price}}</span></p>
					<p class="price-modify">实付金额：<span>￥{{orderFollowList.order_info.order_total_price}}</span></p>
			        <div class="supply-submit">
			        	<span class="cancel" @click="onCloseModalClick">取消</span>
			        	<span class="submit" @click="submitModify">确定</span>
			        </div>
			    </div>
			</common-modal>

			<div class="link-wrap">
				<img src="@/assets/images/order-manage/ic_home_line_6.png" alt="" class="pt-img">
				<span class="service-left">订单进度表</span>
			</div>

			<div class="customer-info">
				<span class="info-style">订单编号</span>
				<span class="info-style info-r">{{orderFollowList.order_info.order_code}}</span>
				<img src="@/assets/images/order-manage/ic_copy.png" alt="" class="copy-logo" @click="utils.copyText(orderFollowList.order_info.order_code)"/>
			</div>

			<div class="customer-info" v-if='orderFollowList.order_info.server_type==1  && (follow=="sale" || follow=="user")'>
				<span class="info-style">买家旺旺</span>
				<span class="info-style limit-wrap">{{orderFollowList.order_info.consumer_wangwang}}</span>
			</div>

			<div class="customer-info" v-if='orderFollowList.order_info.server_type==1 && follow=="admin"'>
				<span class="info-style">卖家旺旺</span>
				<span class="info-style limit-wrap">{{orderFollowList.order_info.merchant_wangwang}}</span>
			</div>

			<div class="customer-info" v-for='(item,index) in orderFollowList.order_info.question_url' :key='index' :class='{"no-h":!item}'>
				<span v-if="item" class="info-style" v-text='orderFollowList.order_info.server_type==1?"商品链接":"商家网址"'></span>
				<span v-if="item" class="info-style info-r info-s">{{item}}</span>
				<img  v-if="item" src="@/assets/images/order-manage/ic_copy.png" alt="" @click="utils.copyText(item)" class="copy-logo"/>
			</div>

			<div class="info-wrap" @click="isShowOption=!isShowOption"  v-show="!isShowOption">
				<img src="@/assets/images/order-manage/ic_more_down.png" class="optional-more">
			</div>

			<template v-if='isShowOption'>
				<div class="customer-info" v-if='follow=="sale" || follow=="admin"'>
					<span class="info-style">订单佣金</span>
					<span class="info-style">¥{{orderFollowList.order_info.commission_price}}</span>
				</div>

				<div class="img-wrap">
					<span class="info-style">订单截图</span>
					<div class="img-list">
						<img v-for="(item,index) in imgList" :key="index" :src="item" alt="" @click="handleImgsClick(imgList,index)" class="upload_img" />
					</div>
				</div>
			</template>
		</div>

		<div class="info-wrap" @click="isShowOption=!isShowOption"  style="margin: 8px 0;"  v-show="isShowOption">
			<img src="@/assets/images/order-manage/ic_more_up.png" class="optional-more" :class='isShowOption?"have-pt":""'>
		</div>

		<div class="btn-wrap">
			<div class="add-money" :class='orderFollowList.order_info.order_status==9?"un-click":""' v-if='follow=="user"' @click="isShowAdd">追加费用</div>
			<div class="add-money" v-if='follow=="sale"' @click="applyHelp">申请协助</div>
			<div class="add-money" v-if='follow=="admin"' @click="isModifymoney=true">修改佣金</div>
			<div class="add-speed" @click="addFollow">添加进度</div>
		</div>

		<ul class="speed">
			<li class="speed-wrap" v-for="(item,index) in followList" :key="index" :class="((follow=='user' && item.is_show == 1) || (follow!='user'))?'':'no-bottom'">
				<template v-if='(follow=="user" && item.is_show == 1) || (follow!="user")'>
					<div class="speed-l">
						<p :class='index==0?"current-l":""' v-if="item.is_admin_assist == 2">求协助</p>
						<p :class='index==0?"current-l":""' v-else>{{item | filterStatus}}</p>
						<!-- <span v-if='follow=="user"'>{{item.create_time.slice(5,10)}}</span> -->
						<span v-if='follow!="user"'>{{item.create_time.slice(5,16)}}</span>
					</div>

					<div class="speed-c" :class='index==0?"first-bg":""'>
						<div :class='index==0?"current-c":""'></div>
					</div>

					<div class="speed-r">
						<!-- <div class="detail" v-if="item.tag">{{item.tag}}</div> -->
						<div class="title" v-if='item.content && ((follow=="user" && item.is_show == 1) || (follow!="user"))' :class='index==0?"current-r":""'>{{item.content}}</div><span class="is-look" v-if='item.type==2 && follow!="user"'>（内部可见）</span></br>
						<div class="img-list" v-if='item.content && ((follow=="user" && item.is_show == 1) || (follow!="user"))'>
							<img v-for="(obj,index) in item.img" :key="index" :src="obj" alt="" @click="handleImgsClick(item.img,index)" class="upload_img" />
						</div>
					</div>
				</template>
			</li>

			<li class="speed-wrap" v-if="orderFollowList.order_info.order_status!=1">
				<div class="speed-l">
					<p>已付款</p>
					<!-- <span v-if='orderFollowList.order_info.pay_time && follow=="user"'>{{(orderFollowList.order_info.pay_time).slice(5,10)}}</span> -->
					<span v-if='orderFollowList.order_info.pay_time && follow!="user"'>{{(orderFollowList.order_info.pay_time).slice(5,16)}}</span>
				</div>

				<div class="speed-c" :class='(!followList.length) && orderFollowList.order_info.order_status!=1?"first-bg":""'>
					<div :class='(!followList.length) && orderFollowList.order_info.order_status!=1?"current-c":""'></div>
				</div>

				<div class="speed-r">
					<div class="title">订单已付款，正在处理</div>
				</div>
			</li>

			<li class="speed-wrap">
				<div class="speed-l">
					<p>待付款</p>
					<!-- <span v-if='orderFollowList.order_info.create_time && follow=="user"'>{{(orderFollowList.order_info.create_time).slice(5,10)}}</span> -->
					<span v-if='orderFollowList.order_info.create_time && follow!="user"'>{{(orderFollowList.order_info.create_time).slice(5,16)}}</span>
				</div>

				<div class="speed-c" :class='(!followList.length) && orderFollowList.order_info.order_status==1?"first-bg":""'>
					<div :class='(!followList.length) && orderFollowList.order_info.order_status==1?"current-c":""'></div>
				</div>

				<div class="speed-r">
					<div class="title">订单未支付款项，等待付款</div>
				</div>
			</li>

		</ul>
	</section>

</template>
<script>
	import ConfirmModal from '@/components/ConfirmModal'
	import PayModal from '@/components/PayModal'
	import ToastModal from '@/components/ToastModal'
	import QrCodeUrl from '@/components/QrCodeUrl'
    import AddMoney from '@/components/AddMoney'
	import SupplyAndFollow from '@/components/SupplyAndFollow'
	import CommonModal from '@/components/CommonModal'
	import {getOrderFollow,getOrderAddPay,getAddPayStatus,orderFollowRecord,adminOrder} from '@/api/order'
	import utils from '@/assets/jslibs/utils'
  import wx from "weixin-js-sdk";
	export default {
		name : 'order-speed',
		data(){
			return{
				utils,
				objSupplyFollow:{title:"添加进度",inputVal:"详细描述有助于处理人员更了解实际情况，提高处理成功率哦..."},
				isSupplyFollow:false,			//是否显示添加进度弹框
				isPayModal:false,
				noEnough:false,
				firmTitle_1:"钱包余额不足 该充值啦",
				firmLeft_1:"返回",
				firmRight_1:"充值",
				wrapperHeight:0,
				allLoaded:false,
				page_index: 1,
				page_size: 25,
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				orderFollowList:{order_info:{},data:[]},
				order_uuid:this.$route.query.order_uuid,
				follow:this.$route.query.follow,
				ToastText:"",     //成功提示语
				isToast:false,
				isMobile : utils.isMobile(),
				imgList:[],		//截图信息
				followList:[],		//进度
				isAddMoney:false,	//是否展示追加费用弹框
				clickPay:true,		//是否可以点击
				addTimer:null,
				add_order_uuid:"",				//追加金额订单
				qrcodeUrl : '',
				payPrice:""	,					//支付金额
				payStyle:1,                	//选择支付的方式
				isModifymoney:false,			//修改佣金弹框
				modifyCommission:"",				//修改后的佣金
				isShowFollow:false,
				addFlag:true,
				isShowOption:false
			}
		},
		components:{
            AddMoney,
			QrCodeUrl,
			PayModal,
			ToastModal,
			ConfirmModal,
			SupplyAndFollow,
			CommonModal
		},

		filters:{
			filterStatus(val){
				if(val.is_add_user=="1"){
					return "商家说"
				}else if(val.is_add_user=="2"){
					return "管理说"
				}else if(val.is_add_user=="3"){
					return utils.statusToName(val.order_status)
				}
			}
		},

		beforeCreate(){
			if(this.$route.query.follow && this.$route.query.follow == "user"){
				sessionStorage.setItem("roleType","customer")
			}else{
				sessionStorage.removeItem("roleType");
			}
		},

		created() {
			window.scrollTo(0,0);
			this.getOrderFollow();
		},

		mounted(){
			this.wrapperHeight = document.documentElement.clientHeight;
			document.title = "跟进记录";

			window.addEventListener('touchmove', (event)=>{
				if(this.isPayModal ||this.isAddMoney || this.noEnough){
		           event.preventDefault();
				}
			})

			window.addEventListener('pageshow',()=>{
			    if(sessionStorage.getItem("haveAddPay") && sessionStorage.getItem("payId")) {
			        this.add_order_uuid = sessionStorage.getItem("payId");      //取追加金额成功支付之后的订单号
			        this.getAddPayStatus();
			        sessionStorage.removeItem("haveAddPay");
			        sessionStorage.removeItem("payId");
			    }
			})
		},

		methods:{
			//查询跟进订单记录
			async getOrderFollow(){
			    let obj = {page_index: this.page_index,page_size: this.page_size};
				const { data, status } = await getOrderFollow(this.order_uuid,obj);
				if (status !== 200) return
			    this.orderFollowList = data;
				if(this.orderFollowList.order_info){
					this.orderFollowList.order_info.question_url = this.orderFollowList.order_info.question_url.split(",")
					this.imgList = JSON.parse(this.orderFollowList.order_info.order_images);
					if(this.imgList && this.imgList.length){
						this.imgList.forEach((item,index)=>{
							if(!item.includes("http") && !item.includes("https")){
								this.imgList[index] = this.imgUrl + this.imgList[index];
							}
						})
					}
				}

				if(this.orderFollowList.data){
					this.followList = this.orderFollowList.data;
					this.followList.forEach((item,index)=>{
						if(item.img && item.img.length){
							item.img.forEach((obj,idx)=>{
								if(!obj.includes("http") && !obj.includes("https")){
									item.img[idx] = this.imgUrl + item.img[idx];
								}
							})
						}
					})
				}
			},

			handleImgsClick(item,index) {
				this.initialIndex = index
				const params = {
					$props: {
						imgs: item,
						initialIndex: 'initialIndex', // 响应式数据的key名
						loop: false
					},
					$events: {
						change: (i) => {
							// 必须更新 initialIndex
							this.initialIndex = i
						}
					}
				}
				this.$createImagePreview({ ...params }).show()
			},

            // 追加费用
            isShowAdd(){
                if(this.orderFollowList.order_info.order_status != 9){
                    this.isAddMoney=true
                }
            },

			//添加进度
			addFollow(){
				this.isSupplyFollow = true;
				if(this.follow == "admin"){//管里员
					this.$set(this.objSupplyFollow,"follow","admin")
				}
				else if(this.follow == "sale"){//业务员
					this.$router.push({path:"./addfollow-sale",query:{order_uuid:this.order_uuid,follow:this.follow}})
					// this.$set(this.objSupplyFollow,"follow","sale");
					// this.$set(this.objSupplyFollow,"num",2);
					// this.$set(this.objSupplyFollow,"title","添加进度");
				}
			},

			//申请协助
			applyHelp(){
				this.isSupplyFollow = true;
				this.objSupplyFollow = {
					title:"申请协助",
					inputVal:"详细描述有助于管理员更了解实际情况，提高处理效率。",
					follow:"sale",
					num:1
				}
			},

			//确认追加费用
			getOrderAdd(addPrice,add_order_uuid){
				this.payPrice = addPrice;
				this.add_order_uuid = add_order_uuid;
				this.isAddMoney = false;
				this.noEnough = false;
				this.isPayModal = true;
			},

			//确认修改佣金
			async submitModify(){
				if(!this.modifyCommission){
					window.toast("请输入金额","txt");
					return;
				}
				if(Number(this.modifyCommission) > Number(this.orderFollowList.order_info.order_total_price)){
					window.toast("佣金金额不得大于订单价格","txt");
					return;
				}
				let obj={type:10,commission_rate:String(Number(this.modifyCommission)/100)};
				const { data, status } = await adminOrder(this.order_uuid,obj);
				if (status !== 200) return;
				this.getOrderFollow();
				this.isModifymoney = false;
				this.ToastText = "佣金修改成功";
				this.isToast = true;
			},

			// 去充值
			goToCharge(){
				this.noEnough = false;
				this.$router.push({path:"./recharge",query: {url:location.href}})
			},

			//确认支付
			async payClick(payStyle){
				this.payStyle = payStyle;
				if(!this.clickPay) {
					window.toast("请勿重复提交","txt");
					return;
				}
				this.clickPay = false;
			    setTimeout(()=>{
			        this.clickPay = true;
			    },3000)

				let obj={add_order_uuid:this.add_order_uuid,type:this.payStyle};
        let web_obj = {type:this.payStyle,order_uuid:this.order_uuid};
				if(this.isMobile==1){
					obj.order_tag = 1
          web_obj.order_tag = 1;
				}else if(this.isMobile==2){
					obj.order_tag = 2
          web_obj.order_tag = 2;
				}else if(this.isMobile==3){
					obj.order_tag = 3
          web_obj.order_tag = 3;
				}


        //判断一下是不是在小程序中
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            // 小程序环境下逻辑
            console.log("小程序环境,需要调用小程序支付");
            //obj.order_tag = 3;
            web_obj.order_tag = 4;
            obj.wx_type   = 'minApp' //小程序
          }
        });

				const { data, status } = await getOrderAddPay(obj);
				if(status==200){//成功支付之后，关闭支付弹框
					if(this.payStyle=="2"){//钱包支付
						this.isPayModal = false;
						this.ToastText = "追加费用成功";
						this.isToast = true;
				        this.getAddPayStatus()
					}
					else{//微信支付
						if(web_obj.order_tag == 2){//扫码支付
							this.isPayModal = false;
							this.qrcodeUrl = data.code_url;
						} else if(web_obj.order_tag == 1){
				            sessionStorage.setItem("haveAddPay","haveAddPay");
				            sessionStorage.setItem("payId",data.add_order_uuid);
							var UserAgent = navigator.userAgent.toLowerCase();
							if(/safari/.test(UserAgent) && !/chrome/.test(UserAgent)){
								var backUrl = "https://server-order.yongxintao.com/#/pay-success?order_uuid="+this.order_uuid+"&totalPrice="+this.payPrice+"&type=add";
								sessionStorage.setItem("backUrl",backUrl);
							    location.href = data.mweb_url;
							}else{
							    location.href = data.mweb_url;
							}

						}else if(web_obj.order_tag == 3){//微信公众号支付
				            let timeStamp = String(data.timeStamp);
				            this.pay("wxf3c9d00e530fedd8",timeStamp,data.nonceStr,data.package,data.signType,data.paySign);
				        }else if (web_obj.order_tag == 4){
              //小程序支付
              //this.AWechatJsPay();
              data.timeStamp = String(data.timeStamp);

              const payParamsStr = encodeURIComponent(JSON.stringify(data));
              const url=`../wxpay/wxpay?payParamsStr=${payParamsStr}`;
              wx.miniProgram.navigateTo({url:url});
              console.log('跳到小程序支付页面中去')
            }
						this.add_order_uuid = data.add_order_uuid;
						this.getAddPayStatus()
					}
				}else{
				    this.isPayModal = false;
				    if(data.error.message == "余额不足" && this.payStyle=="2"){
				        this.noEnough = true;
				    }
				}
			},

			// 调微信支付
			pay(appId,timeStamp,nonceStr,packages,signType,paySign){
				let self = this;
			    if (typeof WeixinJSBridge == "undefined"){
			       if( document.addEventListener ){
			           document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
			       }else if (document.attachEvent){
			           document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
			           document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
			       }
			    }else{
			       self.onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign);
			    }
			},

			//唤醒微信支付
			onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign){
			    let self = this;
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest',
					{
						"appId":"wxf3c9d00e530fedd8",     //公众号名称，由商户传入
						"timeStamp":timeStamp,         //时间戳，自1970年以来的秒数
						"nonceStr":nonceStr, //随机串
						"package":packages,
						"signType":signType,         //微信签名方式：
						"paySign":paySign //微信签名
					},

					function(res){
						if(res.err_msg == "get_brand_wcpay_request:ok"){// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
							self.$router.push({path:"./pay-success",query: {order_uuid:self.order_uuid,totalPrice:self.payPrice,type:'add'}});
						}else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
			                window.toast("支付失败","txt");
						}else if (res.err_msg === 'get_brand_wcpay_request:fail') {
			                window.toast("支付失败","txt");
						}
					}
				)
			},

			// 轮询追加金额订单支付状态
			async getAddPayStatus(){
				clearTimeout(this.addTimer);
				const { data, status } = await getAddPayStatus(this.add_order_uuid);
				if(status == 200){
					if(this.payStyle=="2"){//钱包支付就查询一次，微信支付需要轮询
						if(data.is_pay == 2){
							// this.isPayModal = false;
							// this.ToastText = "追加费用成功";
							// this.isToast = true;
							this.$router.push({path:"./pay-success",query: {order_uuid:this.order_uuid,totalPrice:this.payPrice,type:'add'}});
						}else{
							this.isPayModal = false;
							this.ToastText = "追加费用失败";
							this.isToast = true;
						}
					}else{
						if(data.is_pay == 2){//支付成功
							clearTimeout(this.addTimer);
							this.$router.push({path:"./pay-success",query: {order_uuid:this.order_uuid,totalPrice:this.payPrice,type:'add'}});
						}else{
							clearTimeout(this.addTimer);
							this.addTimer = setTimeout(()=>{
								this.getAddPayStatus()
							},2000)
						}
					}
				}
			},

			// 添加进度
			async submitSupplyAdd(content,img,follow,type){//follow:区分角色,followTag:业务员添加进度的标签,type:是否用户可见
				if(!this.addFlag) {
					window.toast("请勿重复点击","txt");
					return;
				}
				this.addFlag = false;
				setTimeout(()=>{
				    this.addFlag = true;
				},3000)
				let obj={content:content,img:JSON.parse(img),is_admin:1};
				if(follow == "sale"){
					obj.is_admin = 2;
				}
				else if(follow == "admin"){
					obj.is_admin = 1;
					obj.type = type;
				}
				const { status, data } = await orderFollowRecord(this.order_uuid,obj);
				if (status !== 200) return
				this.isSupplyFollow = false;
				this.ToastText = follow=="sale"?"申请协助成功":"添加进度成功";
				this.isToast = true;
				setTimeout(()=>{
					this.getOrderFollow();
					this.isToast = false
				},1500)
			},

			//关闭弹框
			onCloseModalClick(){
				this.isAddMoney = false;
				this.noEnough = false;
				this.isPayModal = false;
				this.isSupplyFollow = false;
				this.qrcodeUrl = "";
				this.isModifymoney = false;
				this.isShowFollow = false
			}
		}
	}
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{background: #fff;font-family:PingFangSC-Medium,PingFang SC;font-weight: 400}
    .link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 20px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;}
	.customer-info{padding: 12px 25px 0px 25px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap}
	.info-style{color: rgba(102,102,102,1);;font-size: 14px}
	.copy-logo{width: 12px;height: 12px}
	.info-r{flex: 1;text-align: right;margin-right: 8px}
	.info-s{ overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-left: 24px;}
	.img-wrap{padding: 12px 25px 27px 25px;}
	.img-list{margin:12px 0;};
	.img-list img{margin-bottom:5px;};
	.upload_img{.w(100);.h(100);border-radius:4px;margin-right: 10px};
	.upload_img:nth-child(3n){margin-right: 0}
	.btn-wrap{padding: 0 25px;display: flex;align-items: center;justify-content: space-between}
	.btn-wrap div{width:156px;height:34px;line-height: 34px;background:rgba(65,132,244,1);border-radius:4px;border:1px solid rgba(65,132,244,0.5);text-align:center;font-size:14px;font-weight:500;color:rgba(255,255,255,1);}

	//跟进记录
	.speed{margin: 24px 10px 100px 35px;background: url(../../assets/images/order-manage/point.png) repeat-y 95px;}
	.speed-wrap{display: flex;margin-bottom: 30px;align-items: flex-start;position:relative;}
	.speed-wrap:last-child{margin-bottom: 0;}
    .no-bottom{margin-bottom: 0;}
	.speed-l{width: 70px;margin-right: 1.0rem;display: flex;flex-direction: column;align-items: flex-end;}
	.speed-l p{font-size:14px;color:rgba(153,153,153,1);margin-bottom: 3px;text-align: right;line-height: 14px;}
	.speed-l span{text-align: right;font-size:12px;color:rgba(153,153,153,1);display: inline-block;width: 80px;}
	.speed-c{display: flex;align-items: center;justify-content: center;width:30px;height:30px;transform: scale(0.5,0.5);-webkit-transform: scale(0.5,0.5);-ms-transform: scale(0.5,0.5);border-radius: 50%;position: absolute;left: 24.2%;margin-top: -9.5px;}
	.first-bg{background:rgba(65,132,244,0.5);}
	.speed-c div{width:12px;height:12px;border-radius: 50%;background:rgba(216,216,216,1);border-radius:50%}
	.speed-r .title{display:inline-block;max-width:210px;padding: 0 10px;line-height: 25px;font-size: 13px;background:rgba(245,245,245,1);border:1px solid rgba(207,207,207,1);color:rgba(76,76,76,1);}
	.speed-r .detail{display: inline-block;max-width:215px;padding: 5px;margin-bottom: 8px;;background:rgba(245,171,21,0.06);border-radius:3px;border:1px solid rgba(245,171,21,0.5);font-size:12px;color:rgba(245,171,21,1);}
	.speed-r .img-list{max-width:215px;}
	.speed-r img{width:66px;height: 66px;border-radius:4px;margin-right:5px;margin-bottom:6px}
	.speed-r img:nth-child(3n){margin-right: 0}
	.speed-l .current-l{color:rgba(5,120,255,1);}
	.speed-r .current-r{background:rgba(240,245,255,1);border:1px solid rgba(65,132,244,1);color:rgba(5,120,255,1);}
	.speed-c .current-c{width:21px;height:21px;background:rgba(65,132,244,1);border-radius: 50%}
	.speed-center{background: rgba(65,132,244,0.5);}
	.no-h{padding: 0;}
	.limit-wrap{margin-right: 0.213333rem; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;flex: 1; margin-right: 0.213333rem;margin-left: 0.64rem;text-align: right;}

	/* .修改佣金 */
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 35px;}
	.modal .title{padding: 12px 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.aim{padding: 47px 0 30px 25px;font-size:15px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color: rgba(20,20,20,1);}
	.aim input{display: inline-block;width:132px;border-bottom: 1px solid #979797;margin: 0 10px;vertical-align: bottom;}
	.supply-wrap /deep/ .modal{padding-bottom: 0}
	.supply-submit{display: flex;align-items: center;justify-content: space-between;width: 100%;height: 49px;margin-top: 44px;color: #ffffff;border-top: 1px solid #DDDDDD;}
	.supply-submit .cancel{width: 50%;height:49px;line-height: 49px;font-size: 18px;color: rgba(153,153,153,1);text-align: center;border-right: 1px solid #DDDDDD}
	.supply-submit .submit{width: 50%;height:49px;line-height: 49px;font-size: 18px;font-weight: 500;color: rgba(65,132,244,1);text-align: center;}
	.price-modify{padding-left: 25px;;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(153,153,153,1);margin-bottom: 5px}
	.is-look{font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(255,134,48,1);}

    .btn-wrap .un-click{background: #ccc;border-radius:4px;border:1px solid #ccc;}

	.info-wrap{padding: 8px 10px;background: #fff}
	.info-wrap .optional-more{width:20px;height:16px;margin: 0 auto;display: block;padding: 10px 0;box-sizing: content-box;}
</style>
